/**
 * JUO Subscription Discount Percentage
 * Displays the discount percentage next to "Subscribe & save" label
 * Updates automatically when subscription frequency changes
 */
(function() {
  'use strict';

  // Store last calculated percentage to prevent unnecessary updates
  var lastCalculatedPercentage = null;

  // Helper: Extract price number from price string (handles European format: €32,00)
  function extractPriceNumber(priceStr) {
    if (!priceStr) return null;
    var cleaned = priceStr.replace(/[€$£¥₹\s]/g, '');
    cleaned = cleaned.replace(',', '.');
    return parseFloat(cleaned);
  }

  // Helper: Get actual price from price container (skips strikethrough)
  function getActualPrice(priceContainer) {
    if (!priceContainer) return null;
    var allMoney = priceContainer.querySelectorAll('.money');
    for (var i = 0; i < allMoney.length; i++) {
      var moneyEl = allMoney[i];
      if (!moneyEl.closest('strike')) {
        var priceText = moneyEl.textContent.trim();
        if (priceText && priceText.match(/[€$£¥₹]|[\d,\.]/)) {
          return priceText;
        }
      }
    }
    return null;
  }

  function updateDiscountPercentage() {
    var widget = document.getElementById('juo-subscription-widget');
    if (!widget) return;

    // Find subscription option
    var subscriptionOption = widget.querySelector('.j-subscription.j-option');
    if (!subscriptionOption) return;

    // Get subscription price container
    var subscriptionPriceContainer = subscriptionOption.querySelector('p.j-price') || subscriptionOption.querySelector('.j-price');
    if (!subscriptionPriceContainer) return;

    // Get subscription price (skip strikethrough)
    var subscriptionPriceText = getActualPrice(subscriptionPriceContainer);
    
    // Get original price (strikethrough price or one-time purchase price)
    var originalPriceEl = subscriptionPriceContainer.querySelector('strike .money') || subscriptionPriceContainer.querySelector('strike');
    var originalPriceText = originalPriceEl ? originalPriceEl.textContent.trim() : null;

    // If no strikethrough, get one-time purchase price
    if (!originalPriceText) {
      var otpOption = widget.querySelector('.j-otp.j-option');
      if (otpOption) {
        var otpPriceContainer = otpOption.querySelector('p.j-price') || otpOption.querySelector('.j-price');
        if (otpPriceContainer) {
          originalPriceText = getActualPrice(otpPriceContainer);
        }
      }
    }

    if (!originalPriceText || !subscriptionPriceText) return;

    // Extract numbers from prices
    var original = extractPriceNumber(originalPriceText);
    var subscription = extractPriceNumber(subscriptionPriceText);

    if (!original || !subscription || original <= subscription) return;

    // Calculate percentage
    var discount = Math.round(((original - subscription) / original) * 100);

    // Only update if percentage changed
    if (lastCalculatedPercentage === discount) return;
    lastCalculatedPercentage = discount;

    // Find the label text element (try multiple selectors)
    var label = subscriptionOption.querySelector('.j-label-inner > span:not(.money)') ||
                subscriptionOption.querySelector('.j-label-inner span:not(.money)') ||
                subscriptionOption.querySelector('.j-label span:not(.money)') ||
                subscriptionOption.querySelector('.j-label-inner');

    if (!label) {
      // Fallback: find any span that contains "Subscribe" or "save"
      var allSpans = subscriptionOption.querySelectorAll('span');
      for (var i = 0; i < allSpans.length; i++) {
        var spanText = allSpans[i].textContent.toLowerCase();
        if (spanText.includes('subscribe') || spanText.includes('save')) {
          label = allSpans[i];
          break;
        }
      }
    }

    if (label) {
      var labelText = label.textContent.trim();
      // Remove existing percentage if present
      labelText = labelText.replace(/\s*\d+%\s*$/, '');
      var newText = labelText + ' ' + discount + '%';
      
      // Only update if text actually changed
      if (label.textContent.trim() !== newText.trim()) {
        label.textContent = newText;
      }
    }
  }

  // Wait for DOM to be ready
  function init() {
    // Listen to changes in JUO widget
    document.addEventListener('change', function(e) {
      if (e.target && e.target.closest && e.target.closest('#juo-subscription-widget')) {
        setTimeout(updateDiscountPercentage, 50);
      }
    }, true);

    // Watch for DOM changes in JUO widget (only price changes, not text changes we make)
    var subWidget = document.getElementById('juo-subscription-widget');
    if (subWidget && window.MutationObserver) {
      var mo = new MutationObserver(function(mutations) {
        // Only react to price-related changes, not text content changes
        var shouldUpdate = false;
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          // Watch for price element changes or checked attribute changes
          if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
            shouldUpdate = true;
            break;
          }
          // Watch for price container changes (new elements added/removed)
          if (mutation.type === 'childList') {
            var target = mutation.target;
            if (target && (target.classList.contains('j-price') || target.querySelector('.money'))) {
              shouldUpdate = true;
              break;
            }
          }
        }
        if (shouldUpdate) {
          setTimeout(updateDiscountPercentage, 100);
        }
      });
      mo.observe(subWidget, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['checked']
      });
    }

    // Initial updates
    updateDiscountPercentage();
    setTimeout(updateDiscountPercentage, 500);
    setTimeout(updateDiscountPercentage, 1500);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

